import { z } from 'zod';

export const subscriptionFormPostRequestSchema = z.object({});
